<template>
    <div class="event" :class="{ full: full }" :data-date="event.event_date">
        <div class="image">
            <div v-if="showSlideshow" class="slideshow-wrap">
                <Slideshow :images="slideshowImages" />
            </div>
            <img v-else-if="image" :src="image" :alt="event.title" loading="lazy" />
        </div>
        <div class="details">
            <template v-if="full">
                <h2>{{ event.title }}</h2>
            </template>
            <template v-else>
                <h3>{{ event.title }}</h3>
            </template>
            <div class="date">{{ eventDate }}</div>
            <div class="bio" v-if="full">
                <div class="teaser" v-show="!showFullBody">
                    <div class="text" v-html="event.teaser"></div>
                    <a @click="showFullBodyToggle = true">More...</a>
                </div>
                <div
                    class="body"
                    v-html="event.body"
                    v-show="showFullBody"
                ></div>
            </div>
        </div>
    </div>
</template>

<script>
import formatDateRange from "@/helpers/formatDateRange.js";
import Slideshow from '@/components/Slideshow.vue';

export default {
    name: "Event",
    components: { Slideshow },
    data() {
        return {
            showFullBodyToggle: false,
        };
    },
    props: {
        event: Object,
        teaser: {
            type: Boolean,
            default: true,
        },
    },
    computed: {
        slideshowImages() {
            const vm = this
            return vm.event.images.map(i => '/'+encodeURI(i.filepath))
        },
        showSlideshow() {
            const vm = this
            return vm.full && vm.event.images.length > 1
        },
        showFullBody() {
            return (
                this.showFullBodyToggle || this.event.body == this.event.teaser
            );
        },
        full() {
            return !this.teaser;
        },
        eventDate() {
            const vm = this;
            if (!vm.event.event_date || vm.event.event_date.length == 0) return;

            const dates = vm.event.event_date.map((d) => new Date(d));
            return formatDateRange(dates);
        },
        image() {
            const vm = this;
            return vm.full ? vm.event.fullImage : vm.event.thumbnail;
        },
    },
};
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped>
</style>
